// Action types
export const FETCH_SURAH_REQUEST = 'FETCH_SURAH_REQUEST';
export const FETCH_SURAH_SUCCESS = 'FETCH_SURAH_SUCCESS';
export const FETCH_SURAH_FAILURE = 'FETCH_SURAH_FAILURE';
export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const USER_LOADED = 'USER_LOADED';
export const INSTRUCTOR_LOADED = 'INSTRUCTOR_LOADED';
export const AUTH_ERROR = 'AUTH_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';
export const GET_PROFILE = 'GET_PROFILE';
export const GET_PROFILES = 'GET_PROFILES';
export const GET_PROFILE_ID = 'GET_PROFILE_ID';
export const GET_REPOS = 'GET_REPOS';
export const NO_REPOS = 'NO_REPOS';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const CLEAR_PROFILE = 'CLEAR_PROFILE';
export const PROFILE_ERROR = 'PROFILE_ERROR';
export const ACCOUNT_DELETED = 'ACCOUNT_DELETED';
export const GET_POSTS = 'GET_POSTS';
export const GET_POST = 'GET_POST';
export const POST_ERROR = 'POST_ERROR';
export const UPDATE_LIKES = 'UPDATE_LIKES';
export const DELETE_POST = 'DELETE_POST';
export const ADD_POST = 'ADD_POST';
export const ADD_COMMENT = 'ADD_COMMENT';
export const REMOVE_COMMENT = 'REMOVE_COMMENT';
export const ADD_COURSE = 'ADD_COURSE';
export const DELETE_COURSE = 'DELETE_COURSE';
export const DELETE_COURSE_CONTENT = 'DELETE_COURSE_CONTENT';
export const GET_COURSE = 'GET_COURSE';
export const GET_INSTRUCTOR_COURSES = 'GET_INSTRUCTOR_COURSES';
export const GET_COURSES = 'GET_COURSES';
export const COURSE_CONTENT_ERROR = 'COURSE_CONTENT_ERROR';
export const COURSE_ERROR = 'COURSE_CONTENT_ERROR';
export const ENROLL_COURSE_SUCCESS = 'ENROLL_COURSE_SUCCESS';
export const GET_ENROLLMENTS_SUCCESS = 'GET_ENROLLMENTS_SUCCESS';
export const GET_ENROLLMENTS_FAIL = 'GET_ENROLLMENTS_FAIL';
export const GET_ENROLLED_STUDENT_SUCCESS = 'GET_ENROLLED_STUDENT_SUCCESS'
export const GET_ENROLLED_STUDENT_FAIL = 'GET_ENROLLED_STUDENT_FAIL'
export const DELETE_ENROLLED_STUDENT_SUCCESS = 'DELETE_ENROLLED_STUDENT_SUCCESS'
export const DELETE_ENROLLED_STUDENT_FAIL = 'DELETE_ENROLLED_STUDENT_FAIL'
export const ENROLL_COURSE_FAIL = 'ENROLL_COURSE_FAIL';
export const GET_ANNOUNCEMENTS = 'GET_ANNOUNCEMENTS';
export const ANNOUNCEMENTS_ERROR = 'ANNOUNCEMENTS_ERROR';
export const RESET_ANNOUNCEMENTS = 'RESET_ANNOUNCEMENTS';
export const REMOVE_ANNOUNCEMENT = 'REMOVE_ANNOUNCEMENT';
export const ADD_ANNOUNCEMENTS = 'ADD_ANNOUNCEMENTS';
export const ASSIGNMENT_UPLOAD_SUCCESS = ' ASSIGNMENT_UPLOAD_SUCCESS';
export const ASSIGNMENT_UPLOAD_FAIL = ' ASSIGNMENT_UPLOAD_FAIL';
export const RESET_ASSIGNMENTS = ' RESET_ASSIGNMENTS';
export const GET_ASSIGNMENTS = 'GET_ASSIGNMENTS';
export const CLEAR_UPLOAD_FORM = 'CLEAR_UPLOAD_FORM';
export const GET_ASSIGNMENTS_SUCCESS = 'GET_ASSIGNMENTS_SUCCESS';
export const GET_ASSIGNMENTS_FAIL = 'GET_ASSIGNMENTS_FAIL';
export const GET_ASSIGNMENT_SUCCESS = 'GET_ASSIGNMENT_SUCCESS';
export const GET_ASSIGNMENT_FAIL = 'GET_ASSIGNMENT_FAIL';
export const DOWNLOAD_ASSIGNMENT_SUCCESS = 'DOWNLOAD_ASSIGNMENT_SUCCESS';
export const DOWNLOAD_ASSIGNMENT_FAIL = 'DOWNLOAD_ASSIGNMENT_FAIL';
export const DELETE_ASSIGNMENT = 'DELETE_ASSIGNMENT';
export const ASSIGNMENT_ERROR = 'ASSIGNMENT_ERROR';
export const UPLOAD_SOLUTION_REQUEST = 'UPLOAD_SOLUTION_REQUEST';
export const UPLOAD_SOLUTION_SUCCESS = 'UPLOAD_SOLUTION_SUCCESS';
export const UPLOAD_SOLUTION_FAILURE = 'UPLOAD_SOLUTION_FAILURE';

export const UPLOADED_SOLUTION_REQUEST = 'UPLOADED_SOLUTION_REQUEST';
export const UPLOADED_SOLUTION_SUCCESS = 'UPLOADED_SOLUTION_SUCCESS';
export const UPLOADED_SOLUTION_FAILURE = 'UPLOADED_SOLUTION_FAILURE';

export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE';

export const VERIFY_RESET_LINK_REQUEST = 'VERIFY_RESET_LINK_REQUEST';
export const VERIFY_RESET_LINK_SUCCESS = 'VERIFY_RESET_LINK_SUCCESS';
export const VERIFY_RESET_LINK_FAILURE = 'VERIFY_RESET_LINK_FAILURE';

export const SET_NEW_PASSWORD_REQUEST = 'SET_NEW_PASSWORD_REQUEST';
export const SET_NEW_PASSWORD_SUCCESS = 'SET_NEW_PASSWORD_SUCCESS';
export const SET_NEW_PASSWORD_FAILURE = 'SET_NEW_PASSWORD_FAILURE';

export const FETCH_QUIZ_REQUEST = 'FETCH_QUIZ_REQUEST';
export const FETCH_QUIZ_SUCCESS = 'FETCH_QUIZ_SUCCESS';
export const FETCH_QUIZ_FAILURE = 'FETCH_QUIZ_FAILURE';

export const FETCH_INSTRUCTOR_QUIZ_REQUEST = 'FETCH_INSTRUCTOR_QUIZ_REQUEST';
export const FETCH_INSTRUCTOR_QUIZ_SUCCESS = 'FETCH_INSTRUCTOR_QUIZ_SUCCESS';
export const FETCH_INSTRUCTOR_QUIZ_FAILURE = 'FETCH_INSTRUCTOR_QUIZ_FAILURE';



export const FETCH_ATTEMPT_QUIZ_REQUEST = 'FETCH_ATTEMPT_QUIZ_REQUEST';
export const FETCH_ATTEMPT_QUIZ_SUCCESS = 'FETCH_ATTEMPT_QUIZ_SUCCESS';
export const FETCH_ATTEMPT_QUIZ_FAILURE = 'FETCH_ATTEMPT_QUIZ_FAILURE';

export const FETCH_ATTEMPT_QUIZ_INSTRUCTOR_REQUEST = 'FETCH_ATTEMPT_QUIZ_INSTRUCTOR_REQUEST';
export const FETCH_ATTEMPT_QUIZ_INSTRUCTOR_SUCCESS = 'FETCH_ATTEMPT_QUIZ_INSTRUCTOR_SUCCESS';
export const FETCH_ATTEMPT_QUIZ_INSTRUCTOR_FAILURE = 'FETCH_ATTEMPT_QUIZ_INSTRUCTOR_FAILURE';

// actions/types.js
export const FETCH_QUIZZES_REQUEST = 'FETCH_QUIZZES_REQUEST';
export const FETCH_QUIZZES_SUCCESS = 'FETCH_QUIZZES_SUCCESS';
export const FETCH_QUIZZES_FAILURE = 'FETCH_QUIZZES_FAILURE';

export const POST_QUIZ = 'POST_QUIZ';
export const POST_QUIZ_SUCCESS = 'POST_QUIZ_SUCCESS';
export const POST_QUIZ_FAILURE = 'POST_QUIZ_FAILURE';

export const UPDATE_QUIZ = 'UPDATE_QUIZ';
export const UPDATE_QUIZ_SUCCESS = 'UPDATE_QUIZ_SUCCESS';
export const UPDATE_QUIZ_FAILURE = 'UPDATE_QUIZ_FAILURE';

export const ATTEMPT_QUIZ = 'ATTEMP_QUIZ'
export const ATTEMPT_QUIZ_SUCCESS = 'ATTEMP_QUIZ_SUCCESS'
export const ATTEMPT_QUIZ_FAILURE = 'ATTEMP_QUIZ_FAILURE'

export const FETCH_COURSE_CONTENT_REQUEST = 'FETCH_COURSE_CONTENT_REQUEST';
export const FETCH_COURSE_CONTENT_SUCCESS = 'FETCH_COURSE_CONTENT_SUCCESS';
export const FETCH_COURSE_CONTENT_FAILURE = 'FETCH_COURSE_CONTENT_FAILURE';

export const FETCH_COURSE_CONTENTS_REQUEST = 'FETCH_COURSE_CONTENTS_REQUEST';
export const FETCH_COURSE_CONTENTS_SUCCESS = 'FETCH_COURSE_CONTENTS_SUCCESS';
export const FETCH_COURSE_CONTENTS_FAILURE = 'FETCH_COURSE_CONTENTS_FAILURE';

export const FETCH_COURSE_CONTENT_REQUEST_BY_INSTRUCTOR = 'FETCH_COURSE_CONTENT_REQUEST_BY_INSTRUCTOR';
export const FETCH_COURSE_CONTENT_SUCCESS_BY_INSTRUCTOR = 'FETCH_COURSE_CONTENT_SUCCESS_BY_INSTRUCTOR';
export const FETCH_COURSE_CONTENT_FAILURE_BY_INSTRUCTOR = 'FETCH_COURSE_CONTENT_FAILURE_BY_INSTRUCTOR';

export const FETCH_COURSE_CONTENTS_REQUEST_BY_INSTRUCTOR = 'FETCH_COURSE_CONTENTS_REQUEST_BY_INSTRUCTOR';
export const FETCH_COURSE_CONTENTS_SUCCESS_BY_INSTRUCTOR = 'FETCH_COURSE_CONTENTS_SUCCESS_BY_INSTRUCTOR';
export const FETCH_COURSE_CONTENTS_FAILURE_BY_INSTRUCTOR = 'FETCH_COURSE_CONTENTS_FAILURE_BY_INSTRUCTOR';

export const FETCH_INSTRUCTORS_REQUEST = 'FETCH_INSTRUCTORS_REQUEST';
export const FETCH_INSTRUCTORS_SUCCESS = 'FETCH_INSTRUCTORS_SUCCESS';
export const FETCH_INSTRUCTORS_FAILURE = 'FETCH_INSTRUCTORS_FAILURE';


export const COURSE_CONTENT_UPLOAD_SUCCESS = 'COURSE_CONTENT_UPLOAD_SUCCESS';
export const COURSE_CONTENT_UPLOAD_FAIL = 'COURSE_CONTENT_UPLOAD_FAIL';

export const COURSE_CONTENT_SHARE_UPLOAD_REQUEST = 'COURSE_CONTENT_SHARE_UPLOAD_REQUEST';
export const COURSE_CONTENT_SHARE_UPLOAD_SUCCESS = 'COURSE_CONTENT_SHARE_UPLOAD_SUCCESS';
export const COURSE_CONTENT_SHARE_UPLOAD_FAIL = 'COURSE_CONTENT_SHARE_UPLOAD_FAIL';

export const DOWNLOAD_COURSE_CONTENT_SUCCESS = 'DOWNLOAD_COURSE_CONTENT_SUCCESS';
export const DOWNLOAD_COURSE_CONTENT_FAIL = 'DOWNLOAD_COURSE_CONTENT_FAIL'

export const FETCH_COURSE_USERS_REQUEST = 'FETCH_COURSE_USERS_REQUEST';
export const FETCH_COURSE_USERS_SUCCESS = 'FETCH_COURSE_USERS_SUCCESS';
export const FETCH_COURSE_USERS_FAILURE = 'FETCH_COURSE_USERS_FAILURE';

export const FETCH_COURSE_USERS_MARKS_REQUEST = 'FETCH_COURSE_USERS_MARKS_REQUEST';
export const FETCH_COURSE_USERS_MARKS_SUCCESS = 'FETCH_COURSE_USERS_MARKS_SUCCESS';
export const FETCH_COURSE_USERS_MARKS_FAILURE = 'FETCH_COURSE_USERS_MARKS_FAILURE';

export const GET_MARKS_BY_ID_REQUEST = 'GET_MARKS_BY_ID_REQUEST'
export const GET_MARKS_BY_ID_SUCCESS = 'GET_MARKS_BY_ID_SUCCESS'
export const GET_MARKS_BY_ID_FAILURE = 'GET_MARKS_BY_ID_FAILURE'

export const FETCH_COURSE_MARKS_REQUEST = 'FETCH_COURSE_MARKS_REQUEST';
export const FETCH_COURSE_MARKS_SUCCESS = 'FETCH_COURSE_MARKS_SUCCESS';
export const FETCH_COURSE_MARKS_FAILURE = 'FETCH_COURSE_MARKS_FAILURE';

export const UPLOAD_MARKS_REQUEST = 'UPLOAD_MARKS_REQUEST';
export const UPLOAD_MARKS_SUCCESS = 'UPLOAD_MARKS_SUCCESS';
export const UPLOAD_MARKS_FAILURE = 'UPLOAD_MARKS_FAILURE';

export const SEARCH_QURAN_REQUEST = 'SEARCH_QURAN_REQUEST';
export const SEARCH_QURAN_SUCCESS = 'SEARCH_QURAN_SUCCESS';
export const SEARCH_QURAN_FAILURE = 'SEARCH_QURAN_FAILURE';

export const GENERATE_QUIZ_REQUEST = 'GENERATE_QUIZ_REQUEST';
export const GENERATE_QUIZ_SUCCESS = 'GENERATE_QUIZ_SUCCESS';
export const GENERATE_QUIZ_FAILURE = 'GENERATE_QUIZ_FAILURE';

// constants.js
export const UPDATE_MARKS_REQUEST = 'UPDATE_MARKS_REQUEST';
export const UPDATE_MARKS_SUCCESS = 'UPDATE_MARKS_SUCCESS';
export const UPDATE_MARKS_FAILURE = 'UPDATE_MARKS_FAILURE';

export const FETCH_UNREAD_NOTIFICATION_COUNT_REQUEST = 'FETCH_UNREAD_NOTIFICATION_COUNT_REQUEST';
export const FETCH_UNREAD_NOTIFICATION_COUNT_SUCCESS = 'FETCH_UNREAD_NOTIFICATION_COUNT_SUCCESS';
export const FETCH_UNREAD_NOTIFICATION_COUNT_FAILURE = 'FETCH_UNREAD_NOTIFICATION_COUNT_FAILURE';

export const FETCH_NOTIFICATIONS_REQUEST = 'FETCH_NOTIFICATIONS_REQUEST';
export const FETCH_NOTIFICATIONS_SUCCESS = 'FETCH_NOTIFICATIONS_SUCCESS';
export const FETCH_NOTIFICATIONS_FAILURE = 'FETCH_NOTIFICATIONS_FAILURE';

export const MARK_NOTIFICATION_AS_READ_REQUEST = 'MARK_NOTIFICATION_AS_READ_REQUEST'
export const MARK_NOTIFICATION_AS_READ_SUCCESS = 'MARK_NOTIFICATION_AS_READ_SUCCESS'
export const MARK_NOTIFICATION_AS_READ_FAILURE = 'MARK_NOTIFICATION_AS_READ_FAILURE'

export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE';
export const CHANGE_PASSWORD_RESET_ERROR = 'CHANGE_PASSWORD_RESET_ERROR';

export const UPDATE_COMMENT_LIKE = 'UPDATE_COMMENT_LIKE';

export const ADMIN_LOADED  = 'ADMIN_LOADED';

export const GET_VERIFIED_INSTRUCTORS= 'GET_VERIFIED_INSTRUCTORS';
export const APPROVE_INSTRUCTOR='APPROVE_INSTRUCTOR';
export const  DELETE_INSTRUCTOR ='DELETE_INSTRUCTOR';
export const TOGGLE_BLOCK_INSTRUCTOR='TOGGLE_BLOCK_INSTRUCTOR';
export const GET_UNVERIFIED_INSTRUCTORS='GET_UNVERIFIED_INSTRUCTORS';
export const GET_VERIFIED_USERS= 'GET_VERIFIED_USERS';
export const  DELETE_USER ='DELETE_USER';
export const TOGGLE_BLOCK_USER='TOGGLE_BLOCK_USER';
export const ADMIN_DELETE_COURSE ='ADMIN_DELETE_COURSE';
export const ADMIN_GET_COURSES ='ADMIN_GET_COURSES';

// contactActionTypes.js
export const DELETE_CONTACT_REQUEST = 'DELETE_CONTACT_REQUEST';
export const DELETE_CONTACT_SUCCESS = 'DELETE_CONTACT_SUCCESS';
export const DELETE_CONTACT_FAILURE = 'DELETE_CONTACT_FAILURE';

export const FETCH_CONTACTS_REQUEST = 'FETCH_CONTACTS_REQUEST';
export const FETCH_CONTACTS_SUCCESS = 'FETCH_CONTACTS_SUCCESS';
export const FETCH_CONTACTS_FAILURE = 'FETCH_CONTACTS_FAILURE';

export const FETCH_CONTACT_COUNT_REQUEST = 'FETCH_CONTACT_COUNT_REQUEST';
export const FETCH_CONTACT_COUNT_SUCCESS = 'FETCH_CONTACT_COUNT_SUCCESS';
export const FETCH_CONTACT_COUNT_FAILURE = 'FETCH_CONTACT_COUNT_FAILURE';

export const SUBMIT_CONTACT_REQUEST = 'SUBMIT_CONTACT_REQUEST';
export const SUBMIT_CONTACT_SUCCESS = 'SUBMIT_CONTACT_SUCCESS';
export const SUBMIT_CONTACT_FAILURE = 'SUBMIT_CONTACT_FAILURE';
export const FETCH_SHARED_COURSE_CONTENT_FAILURE ='FETCH_SHARED_COURSE_CONTENT_FAILURE' ;
export const  FETCH_SHARED_COURSE_CONTENT_SUCCESS ='FETCH_SHARED_COURSE_CONTENT_SUCCESS';
export const  FETCH_SHARED_COURSE_CONTENT_REQUEST ='FETCH_SHARED_COURSE_CONTENT_REQUEST';

export const FETCH_TITLES_SUCCESS = 'FETCH_TITLES_SUCCESS';
export const FETCH_TITLES_FAILURE = 'FETCH_TITLES_FAILURE';
export const FETCH_TITLES_REQUEST = 'FETCH_TITLES_REQUEST';

export const DELETE_MARKS_REQUEST = 'DELETE_MARKS_REQUEST';
export const DELETE_MARKS_SUCCESS = 'DELETE_MARKS_SUCCESS';
export const DELETE_MARKS_FAILURE = 'DELETE_MARKS_FAILURE';

export const FETCH_MARKS_SUCCESS = 'FETCH_MARKS_SUCCESS';
export const FETCH_MARKS_FAILURE = 'FETCH_MARKS_FAILURE';
export const EDIT_MARKS_SUCCESS = 'EDIT_MARKS_SUCCESS';
export const EDIT_MARKS_FAILURE = 'EDIT_MARKS_FAILURE';
export const FETCH_MARK_BY_ID_SUCCESS = 'FETCH_MARK_BY_ID_SUCCESS';
export const FETCH_MARK_BY_ID_FAILURE = 'FETCH_MARK_BY_ID_FAILURE';



export const ADD_ANNOUNCEMENT_COMMENT = 'ADD_ANNOUNCEMENT_COMMENT';
export const REMOVE_ANNOUNCEMENT_COMMENT ='REMOVE_ANNOUNCEMENT_COMMENT';

export const UPDATE_COMMENT = 'UPDATE_COMMENT';
// Add a constant for update announcement
export const UPDATE_ANNOUNCEMENT = 'UPDATE_ANNOUNCEMENT';

export const FORUM_POST_UPDATED = 'FORUM_POST_UPDATED';
export const FORUM_COMMENT_UPDATED = 'FORUM_COMMENT_UPDATED';